// Central brand identity / NAP (Name, Address, Phone) used across the site.
// SINGLE SOURCE OF TRUTH for the official phone + WhatsApp contacts (US primary, UK secondary).
// Every WhatsApp button / Strategy Call CTA MUST use BRAND.whatsappUrl below.
export const BRAND = {
  name: "WebsiteAndGo",
  legalName: "WebsiteAndGo",
  description: "AI-powered digital agency serving US trades, contractors and home-service businesses — premium websites, local SEO, AI automation and SaaS solutions that generate more calls and quote requests.",
  url: "https://websiteandgo.com",
  logo: "/logo.png",
  email: "contact@websiteandgo.com",
  mailto: "mailto:contact@websiteandgo.com",
  phoneDisplay: "+1 808-998-5633",
  phoneTel: "tel:+18089985633",
  // Canonical WhatsApp identity — single source of truth.
  whatsappNumber: "18089985633",
  whatsappUrl: "https://wa.me/18089985633",
  // Backwards-compat: /api/wa is the tracked redirect; still points to whatsappUrl.
  whatsappLink: `${process.env.REACT_APP_BACKEND_URL}/api/wa`,
  whatsappDefault: "Hello WebsiteAndGo, I'm interested in learning more about your websites, local SEO, lead generation and AI automation services.",
  uk: {
    address: "Luton, England",
    phoneDisplay: "+44 7463 638059",
    phoneTel: "tel:+447463638059",
    whatsappUrl: "https://wa.me/447463638059",
  },
  addressLocality: "Lincoln Metro",
  addressRegion: "Nebraska",
  postalCode: "",
  addressCountry: "US",
  serviceArea: "United States",
  geo: { latitude: 40.8136, longitude: -96.7026 },
  hours: "Mo-Fr 09:00-18:00",
  founded: "2019",
  social: {},
};

// Build a WhatsApp URL with a pre-filled message and optional placement tag.
// Uses direct wa.me link (single source of truth) so no reference to the old
// number can ever leak — the number lives ONLY in this file.
export function waHref(placement = "cta", region = "us") {
  const msg = `${BRAND.whatsappDefault} (Source: ${placement})`;
  const base = region === "uk" ? BRAND.uk.whatsappUrl : BRAND.whatsappUrl;
  return `${base}?text=${encodeURIComponent(msg)}`;
}
